var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValidateUnfilled = function SvgValidateUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8ZM7 8.79999L10.3 5.29999C10.7 4.89999 11.3 4.89999 11.7 5.19999C12.1 5.59999 12.1 6.24999 11.7 6.64999L8.05 10.5C7.8 10.8 7.4 10.95 7 10.95C6.6 10.95 6.25 10.8 5.95 10.55L4.3 8.69999C3.9 8.29999 3.9 7.69999 4.3 7.29999C4.7 6.89999 5.3 6.89999 5.7 7.29999L7 8.79999Z"
  })));
};
export default SvgValidateUnfilled;